// non-template file
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { Roles } from "@/helpers/enums/Roles";
import $ from "jquery";
import { useStore } from "@/store";

const store = useStore();

const data: any = {
  filter: {
    title: "partnerfilter",
    pageName: "partnerfilter",
    genre: "filter",
    noDateSelect: true,
    ignoreSaveFilter: true,
    hideFilter: false,
    filters: [
      {
        title: "name",
        type: "wordstyped",
        apiEquivalent: "name",
        param: "name",
        vmodel: "",
      },
      {
        title: "shortName",
        type: "wordstyped",
        apiEquivalent: "shortName",
        param: "shortName",
        vmodel: "",
      },
      {
        title: "contactName",
        type: "wordstyped",
        apiEquivalent: "contactName",
        param: "contactName",
        vmodel: "",
      },
      {
        title: "contactPhone",
        type: "wordstyped",
        apiEquivalent: "contactPhone",
        param: "contactPhone",
        vmodel: "",
      },
      {
        title: "contactEmail",
        type: "wordstyped",
        apiEquivalent: "contactEmail",
        param: "contactEmail",
        vmodel: "",
      },
    ],
  },
  header: {
    title: "partnerList",
    buttonPosition: "justify-content-between",
    buttons: [
      {
        title: "newPartner",
        icon: "add",
        class: "primary mr-3",
        link: "",
        target: "#agPartnerModal",
        toggle: "modal",
        function: (module: any) => {
          store.dispatch(
            GeneralActionTypes.SET_COMPKEY,
            store.getters.compKey + 1
          );
        },
      },
    ],
  },
  component: {
    type: "ag-table",
    options: {
      columns: [
        {
          label: "name",
          field: "name",
          sortable: true,
          changeScope: true
        },
        {
          label: "shortName",
          field: "shortName",
          sortable: true,
        },
        {
          label: "contactName",
          field: "contactName",
          sortable: true,
        },
        {
          label: "contactPhone",
          field: "contactPhone",
          sortable: true,
        },
        {
          label: "email",
          field: "contactEmail",
          sortable: true,
        },
        {
          label: "commands",
          field: "commands",
          components: [
            {
              component: "tableEditComponent",
              target: "#agPartnerModal",
            },
            {
              component: "tableDeleteComponent",
              class: "mr-2 ml-2",
            },
          ],
        },
      ],
      rows: [],
      sortable: {
        order: "name",
        sort: "desc",
      },
      total: 0,
      page: 1,
      pageSize: 10,
      isLoading: false,
      dateFilter: false,
      fetchTable: (options: any) => {
        const filters = data.readyToUseFilters; //data.filter
        const body = { filters, options };

        store.dispatch(GeneralActionTypes.GET_PARTNERS, body);
      },
    },
  },
};

export default data;
